module.exports = __webpack_public_path__ + "img/reticule5.d2ad20b0.jpg";